module.exports = __webpack_public_path__ + "img/ce87fc7.jpg";